import React from 'react';
import PropTypes from 'prop-types';
import BooleanDiff from './BooleanDiff';
import StringDiff from './StringDiff';
import UrlDiff from './UrlDiff';
import JsonDiff from './JsonDiff';
import { isSecretField } from './utils';

const MASKED = '••••••';

// Secrets are masked server-side (old value fully masked, new value revealing
// only the last 3 characters, e.g. "*****xyz"). Render whatever the API sent.
// Defense in depth: if a value somehow arrives unmasked, mask it fully here.
function displaySecret(value) {
  if (value === null || value === undefined || value === '') return value;
  const str = String(value);
  if (str.includes('*') || str.includes('•')) return str;
  return MASKED;
}

export default function SmartDiff({
  change,
  compact = false,
  diffStyle = 'smart',
  fieldName = '',
}) {
  const { from, to, type } = change;

  if (isSecretField(fieldName)) {
    return (
      <StringDiff
        from={displaySecret(from)}
        to={displaySecret(to)}
        compact={compact}
      />
    );
  }

  if (diffStyle === 'simple') {
    return <StringDiff from={from} to={to} compact={compact} />;
  }

  switch (type) {
    case 'boolean':
      return <BooleanDiff from={from} to={to} />;
    case 'url':
      return <UrlDiff from={from} to={to} />;
    case 'json':
      return <JsonDiff from={from} to={to} />;
    default:
      return <StringDiff from={from} to={to} compact={compact} />;
  }
}
SmartDiff.propTypes = {
  change: PropTypes.shape({
    from: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array,
    ]),
    to: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array,
    ]),
    type: PropTypes.string.isRequired,
  }).isRequired,
  compact: PropTypes.bool,
  diffStyle: PropTypes.oneOf(['smart', 'simple']),
  fieldName: PropTypes.string,
};
